import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
	string,
	func,
	arrayOf,
	node,
	oneOfType,
	bool,
	shape
} from 'prop-types';

// Import styles
import { LinkContainer } from './styles';

// Import variables
import { SLIDER_DRAG_MINIMUM_POSITION_CHANGE } from 'helpers/variables';

const ItemLink = ({ to, gtmEvent, children, isStyledByChildren = false }) => {
	const history = useHistory();
	const dragCoordinates = useRef({ x: 0, y: 0 });

	const handleMouseUp = (e) => {
		const diffX = Math.abs(e.pageX - dragCoordinates.current.x);
		const diffY = Math.abs(e.pageY - dragCoordinates.current.y);

		const isDragged =
			diffX > SLIDER_DRAG_MINIMUM_POSITION_CHANGE ||
			diffY > SLIDER_DRAG_MINIMUM_POSITION_CHANGE;

		// If item is dragged prevent redirect to product
		if (isDragged) return;

		history.push(to);
		gtmEvent && gtmEvent();
	};

	const handleMouseDown = (e) => {
		dragCoordinates.current = {
			x: e.pageX,
			y: e.pageY
		};
	};

	return (
		<LinkContainer
			onMouseUp={handleMouseUp}
			onMouseDown={handleMouseDown}
			isStyledByChildren={isStyledByChildren}
		>
			{children}
		</LinkContainer>
	);
};

ItemLink.propTypes = {
	to: oneOfType([string, shape({ pathname: string.isRequired })]).isRequired,
	gtmEvent: func,
	children: oneOfType([arrayOf(node), node]),
	isStyledByChildren: bool
};

export default ItemLink;
